"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('teeth', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1169 5H14.0024C18.6684 5.68989 19.9338 8.33825 24 8.33825C28.0662 8.33825 29.3312 5.69005 33.9975 5H34.5C39.7467 5 44 9.25329 44 14.5V15.1259C44 18.0287 40.9088 21.3433 40 24.4829C39.0348 27.8174 38.3734 30.5425 38.1793 33.3943C37.7246 40.0751 35.4467 43 33 43C29.3462 43 26.1014 28.0251 24.0624 28.0251C22.0234 28.0251 17.9773 43 15 43C13.183 43 10.8291 41.9254 9.94527 33.3943C9.59364 30 9.00095 27.9407 8.00001 24.4829C7.12023 21.4437 4.15171 17.8111 4.00001 14.5511C3.7657 9.51593 7.65754 5.24419 12.6927 5.00988C12.834 5.00331 12.9755 5.00002 13.1169 5Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }), _react.default.createElement("path", {
    d: "M15.4819 12.4634L32 17.7887",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M15.4819 17.7886L32 12.4632",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;